import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react'
import moment from 'moment'
import { parseAsString, useQueryState } from 'nuqs'

import { Button } from '@/components/ui/button'

import { ButtonGroup } from '../ui/button-group'

export const DatePaginator = () => {
  const currentDate = moment()
  const currentDateString = currentDate.format('YYYY-MM-DD')

  const [activeDate, setActiveDate] = useQueryState(
    'date',
    parseAsString.withDefault(currentDateString),
  )

  return (
    <div className="flex justify-between gap-2">
      <ButtonGroup orientation="horizontal">
        <Button
          variant="outline"
          onClick={() => {
            setActiveDate(moment(activeDate).subtract(1, 'day').format('YYYY-MM-DD'))
          }}
        >
          <ArrowLeftIcon className="size-4" />
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            setActiveDate(currentDateString)
          }}
        >
          {moment(activeDate).format('DD.MM.YYYY')}
        </Button>
        <Button
          variant="outline"
          disabled={activeDate === currentDateString}
          onClick={() => {
            setActiveDate(moment(activeDate).add(1, 'day').format('YYYY-MM-DD'))
          }}
        >
          <ArrowRightIcon className="size-4" />
        </Button>
      </ButtonGroup>
    </div>
  )
}
